import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import TrionixLogo from "@/components/TrionixLogo";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed top-0 left-0 z-50 transition-all duration-300"
      style={{ background: 'transparent' }}
    >
      <div className="px-4 py-3 md:px-6 md:py-4" style={{ background: 'transparent' }}>
        <button
          onClick={scrollToTop}
          className="flex items-center gap-3 hover:opacity-80 transition-opacity group p-0 m-0"
          style={{ 
            background: 'transparent', 
            boxShadow: 'none',
            border: 'none',
            outline: 'none',
            isolation: 'isolate'
          }}
          aria-label="Go to home"
        >
          <TrionixLogo size={80} variant="icon" className="group-hover:scale-105 transition-transform" />
          <div className="flex flex-col" style={{ background: 'transparent' }}>
            <span 
              className="text-lg md:text-xl font-bold text-white"
              style={{ background: 'transparent', isolation: 'isolate' }}
            >
              TRIONIX
            </span>
            <span 
              className="text-xs md:text-sm text-[#B0B3B8] -mt-1"
              style={{ background: 'transparent', isolation: 'isolate' }}
            >
              Technologies
            </span>
          </div>
        </button>
      </div>
    </motion.header>
  );
};

export default Header;
